<div class="container" *transloco="let t">
  <div class="row my-4">
    <div class="col-12 col-lg-8 mb-4">
      <h1 class="my-4">CONDITIONS DE PUBLICATION</h1>
      <p>
        Dernière mise à jour : 7 août 2025
      </p>
      <p class="my-2">
        <strong>Note</strong>: ces conditions s'appliquent aux usagés connectés, notamment aux organisateurs d'activités qui publient des activités de loisirs.
      </p>

      <section>
        <h3>1. Objet</h3>
        <p>
          Les présentes conditions complètent les <a [routerLink]="routes.terms">Conditions Générales d’Utilisation</a> applicables à tous les utilisateurs de l’Application {{ appName }}. Elles définissent les règles spécifiques applicables aux utilisateurs connectés qui publient des activités sur l’Application.
        </p>
        <p>
          En créant un compte et en publiant une activité, l’utilisateur accepte sans réserve les présentes conditions.
        </p>
      </section>

      <section>
        <h3>2. Création de compte</h3>
        <ul>
          <li>La création d’un compte est obligatoire pour pouvoir publier une activité.</li>
          <li>L’utilisateur s’engage à fournir des informations exactes, complètes et à jour lors de la création et de la mise à jour de son compte.</li>
          <li>L’Association se réserve le droit de refuser ou de suspendre un compte en cas de non-respect des présentes conditions ou des lois en vigueur.</li>
        </ul>
      </section>

      <section>
        <h3>3. Règles de publication</h3>
        <ul>
          <li>L’utilisateur peut publier des activités de loisir se déroulant en Suisse, sous réserve du respect des règles suivantes :</li>
          <li>Les activités doivent correspondre à la mission de l’Application (loisirs uniquement).</li>
          <li>Les contenus à caractère politique, religieux, discriminatoire, violent, dangereux ou illégal sont interdits.</li>
          <li>Les publications doivent être rédigées dans un langage clair et respectueux.</li>
          <li>Les photos et autres médias publiés doivent appartenir à l’utilisateur ou être libres de droits, et ne pas porter atteinte aux droits de tiers.</li>
        </ul>
      </section>

      <section>
        <h3>4. Responsabilité de l’utilisateur</h3>
        <ul>
          <li>L’utilisateur est seul responsable des informations, images et contenus qu’il publie.</li>
          <li>L’utilisateur garantit l’Association contre toute réclamation ou action d’un tiers relative à ses publications.</li>
          <li>L’utilisateur s’engage à mettre à jour les informations en cas de changement ou d’annulation de l’activité.</li>
        </ul>
      </section>

      <section>
        <h3>5. Modération et suppression</h3>
        <ul>
          <li>Les publications peuvent faire l’objet d’une vérification par l’Association avant mise en ligne.</li>
          <li>L’Association se réserve le droit de modifier ou supprimer toute publication, à tout moment et sans préavis, y compris après sa mise en ligne, sans obligation de justification.</li>
          <li>Les décisions de modération sont discrétionnaires et ne donnent droit à aucune compensation.</li>
        </ul>

      </section>

      <section>
        <h3>6. Utilisation des contenus par l’Association</h3>

        <p>
          En publiant une activité, l’utilisateur autorise l’Association à :
        </p>
        <ul>
          <li>Reproduire, adapter, traduire et diffuser le contenu de sa publication sur l’Application et dans tout support de communication lié (réseaux sociaux, newsletters, présentations, etc.) ;</li>
          <li>Utiliser les contenus à des fins de référencement (SEO) et de promotion interne ou externe ;</li>
          <li>Faciliter le partage de la publication sur les réseaux sociaux et autres plateformes.</li>
        </ul>
        <p>
          Cette autorisation est consentie à titre gratuit, pour le monde entier et pour toute la durée de mise en ligne de l’activité.
        </p>
      </section>

      <section>
        <h3>7. Protection des données</h3>
        <ul>
          <li>
            Les données fournies lors de la création d’un compte et de la publication d’une activité sont traitées conformément à la politique de confidentialité de l’Application et à la nLPD.
          </li>
          <li>
            L’utilisateur peut demander la suppression de son compte et de ses publications en contactant l’Association par email.
          </li>
        </ul>
      </section>

      <section>
        <h3>8. Sanctions en cas de non-respect</h3>
        <p>
          En cas de violation des présentes conditions, l’Association pourra, à sa seule discrétion :
        </p>
        <ul>
          <li>Supprimer la publication concernée ;</li>
          <li>Suspendre ou supprimer le compte de l’utilisateur ;</li>
          <li>Refuser toute nouvelle publication.</li>
          <li>L’Application est conforme à la nLPD (Nouvelle Loi fédérale sur la protection des données).</li>
        </ul>
      </section>

      <section>
        <h3>9. Droit applicable et juridiction compétente</h3>
        <p>
          Les présentes conditions sont régies par le droit suisse.
          Tout litige relatif à leur interprétation ou à leur exécution relève de la compétence exclusive des tribunaux de Neuchâtel en Suisse.
        </p>
      </section>

      <section>
        <h3>10. Droit applicable et juridiction compétente</h3>
        <p>Les présentes CGU sont régies par le droit suisse.</p>
        <p>Tout litige relatif à l’utilisation de l’Application relève de la compétence exclusive des tribunaux de Neuchâtel en Suisse.</p>
      </section>

      <section>
        <h3>11. Langue applicable</h3>
        <p>L’Application peut être disponible en plusieurs langues.</p>
        <p>En cas de divergence entre les versions, la version française fait foi.</p>
      </section>
    </div>
  </div>
</div>
